// Core packages
import { Component, Input } from "@angular/core";

// Third party packages

// Custom packages

@Component({
  selector: "app-card-spinner",
  templateUrl: "./card-spinner.component.html",
  styleUrls: ["./card-spinner.component.scss"]
})
export class CardSpinnerComponent {
  @Input("visible") visible: boolean;
  @Input("type") type: boolean;
}
